import React from 'react';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { Localized, useLocale } from '../../i18n/I18n';
import { contactData } from '../../data/mock';
import './support.css';

const supportOptions = [
  ['Remoto', 'Diagnóstico y asistencia sin desplazamientos.'],
  ['Presencial', 'Atención en tu empresa cuando el caso lo requiere.'],
  ['Preventivo', 'Mantenimiento para anticipar fallas en tus equipos.'],
  ['Con seguimiento', 'Un alcance claro y acompañamiento en cada caso.'],
];

export default function BusinessSupport() {
  const { t } = useLocale();
  const whatsapp = 'https://wa.me/' + contactData.whatsapp.replace(/\D/g, '') + '?text=' + encodeURIComponent(t('Hola Bezalel, me gustaría conocer el soporte para mi empresa.'));
  return <Localized><section className="bz-business-support bz-section" id="soporte-empresarial" aria-labelledby="bz-support-title">
    <div className="bz-shell bz-support-layout">
      <figure className="bz-support-photo bz-reveal">
        <img src="/assets/editorial/soporte-empresarial.webp" alt="Escena ilustrativa de un especialista de soporte atendiendo una consulta desde su computador" width="960" height="1200" loading="lazy" decoding="async"/>
        <figcaption><span>Personas detrás de la tecnología.</span><span>Soporte Bezalel</span></figcaption>
      </figure>
      <div className="bz-support-copy bz-reveal">
        <p className="bz-eyebrow">SOPORTE PARA EMPRESAS</p>
        <h2 id="bz-support-title">Que un problema técnico <span>no detenga tu equipo.</span></h2>
        <p className="bz-support-intro">Equipos, software y conectividad. Te ayudamos a resolver lo que frena tu día a día.</p>
        <dl className="bz-support-options">{supportOptions.map(([title, description]) => <div key={title}><dt>{title}</dt><dd>{description}</dd></div>)}</dl>
        <div className="bz-support-actions">
          <a className="bz-support-cta" href={whatsapp} target="_blank" rel="noopener noreferrer">Habla con un experto <ArrowUpRight size={18} aria-hidden="true"/></a>
          <a className="bz-support-details" href="/servicios/soporte-computo">Conocer el soporte <ArrowRight size={17} aria-hidden="true"/></a>
        </div>
        <p className="bz-support-schedule">Horario y cobertura acordados con cada empresa.</p>
      </div>
    </div>
  </section></Localized>;
}
